/**
 * Session-based watched time tracker.
 *
 * Accumulates wall-clock seconds the user actually spends watching video —
 * survives replays, rewinds, and multi-pass sessions within one player open.
 *
 * Usage:
 *   watchTimeTracker.start()      // call on 'playing'
 *   watchTimeTracker.pause()      // call on 'pause' (also fires before 'seeking')
 *   watchTimeTracker.getSeconds() // read before sending analytics events
 */

let accumulated = 0;
// Date.now() of the current start; null while paused.
let startTime: number | null = null;

/**
 * Start (or resume) the stopwatch.
 * No-op if already running.
 */
export function start() {
  if (startTime === null) {
    startTime = Date.now();
  }
}

/**
 * Pause the stopwatch and bank elapsed ms.
 * No-op if already paused.
 */
export function pause() {
  if (startTime !== null) {
    accumulated += Date.now() - startTime;
    startTime = null;
  }
}

/**
 * Total watched seconds (rounded), including currently-running interval.
 */
export function getSeconds() {
  let total = accumulated;
  if (startTime !== null) {
    total += Date.now() - startTime;
  }
  return Math.round(total / 1000);
}

/**
 * Reset the tracker (e.g. when a new experience loads).
 */
export function reset() {
  accumulated = 0;
  startTime = null;
}
